import { render } from "./BudgetSection.vue?vue&type=template&id=6041e62b&scoped=true"
import script from "./BudgetSection.vue?vue&type=script&lang=js"
export * from "./BudgetSection.vue?vue&type=script&lang=js"

import "./BudgetSection.vue?vue&type=style&index=0&id=6041e62b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6041e62b"]])

export default __exports__